// Хвост для прочих ссылок пиксель аудита
export const closingPixelAuditForOtherLinks = '' as const;

export const pixelEventUrls: string[] = [
  'ev.adriver.ru/cgi-bin/event.cgi',
  'wcm-ru.',
] as const;

export const pixelEventFields = [
  'show',
  'show2',
  'show3',
  'data.audit.click',
  'data.audit.close',
  'data.audit.collapse',
  'data.audit.exitfs',
  'data.audit.expand',
  'data.audit.fullscreen',
  'data.audit.mute',
  'data.audit.pause',
  'data.audit.resume',
  'data.audit.rewind',
  'data.audit.show',
  'data.audit.show2',
  'data.audit.show3',
  'data.audit.skip',
  'data.audit.sprogresshow',
  'data.audit.unmute',
  'data.audit.view_0',
  'data.audit.view_25',
  'data.audit.view_50',
  'data.audit.view_75',
  'data.audit.view_100',
];
